import './About.css';

export default function About(){
    return(
        <>
        <div class="about">
            
              <div class="info">
                 <img src="https://www.newtom.it/media/filer_public_thumbnails/filer_public/29/9a/299a9651-aad4-4ea8-bb8b-e9a4c6e3dd04/2013.jpg"></img>
                 
             </div>
             <div class="intro">
                 <p>At 3rd I, we pride ourselves on using the latest in imaging technology, including Cone Beam CT (CBCT) and Orthopantomography (OPG), to offer 3D and panoramic scans of unparalleled clarity. These advanced tools allow us to provide detailed views of the dental, oral, and maxillofacial regions, which are crucial for accurate diagnosis, treatment planning, and surgical procedures.
                 Our CBCT scans offer low-radiation, high-definition imaging, ideal for detecting complex structures like impacted teeth, fractures, bone abnormalities, and pathologies. Whether you’re preparing for dental implants, orthodontic treatment, or oral surgery, our cutting-edge equipment ensures that both patients and practitioners have the data they need to make informed decisions.</p>
                 <button>Know More</button>
            </div>
        
        </div>

        

        </>
    )
}


 
